import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useSession } from 'components/sessions/context/SessionContext';

const SessionProfitChart = () => {
  const { sessions } = useSession();

  const processChartData = () => {
    if (!sessions.length) return [];

    const sortedSessions = [...sessions].sort((a, b) => 
      new Date(a.date) - new Date(b.date)
    );

    let cumulativeHours = 0;
    let cumulativePL = 0;

    const result = [];

    sortedSessions.forEach((session) => {
      const hours = session.sessionHours || 0;
      
      result.push({
        hours: cumulativeHours,
        profitLoss: cumulativePL,
      });

      cumulativeHours += hours;
      cumulativePL += session.profitLoss;

      result.push({
        hours: cumulativeHours,
        profitLoss: cumulativePL,
      });
    });

    return result;
  };

  const chartData = processChartData();
  const maxHours = chartData.length > 0 ? chartData[chartData.length - 1].hours : 1;

  const formatHours = (hours) => {
    const h = Math.floor(hours);
    const m = Math.round((hours - h) * 60);
    return m > 0 ? `${h}h${m}m` : `${h}h`;
  };

  return (
    <div className="w-full p-8">
      <div className="w-full max-w-6xl mx-auto">
        <h2 className="text-2xl font-bold mb-6 text-gray-100">Profit/Loss Over Playing Time</h2>
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#374151" opacity={0.3} />
            <XAxis 
              dataKey="hours"
              type="number"
              domain={[0, maxHours]}
              tickFormatter={formatHours}
              stroke="#9ca3af"
              tick={{ fill: '#9ca3af' }}
              label={{ value: 'Total Hours Played', position: 'insideBottom', offset: -5, fill: '#9ca3af' }}
            />
            <YAxis 
              stroke="#9ca3af"
              tick={{ fill: '#9ca3af' }}
              label={{ value: 'Cumulative P/L', angle: -90, position: 'insideLeft', fill: '#9ca3af' }}
            />
            <Tooltip 
              formatter={(value) => [`${value}`, 'P/L']}
              labelFormatter={(hours) => formatHours(hours)}
              contentStyle={{ 
                backgroundColor: '#1f2937', 
                border: '1px solid #374151',
                borderRadius: '6px',
                color: '#f3f4f6'
              }}
              labelStyle={{ color: '#9ca3af' }}
            />
            <Line 
              type="linear" 
              dataKey="profitLoss" 
              stroke="#3b82f6" 
              strokeWidth={2}
              dot={false}
              isAnimationActive={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default SessionProfitChart;
